import React, {useState, useEffect} from 'react';
import { ItemEmpty, VideoLoader, ProgressBar } from '../components/UXHelper';
import './styles/expeditions.css';
import { JsonRpc } from 'eosjs';
import { ItemsVertical } from '../components/Items';
import { useParams } from 'react-router-dom';
import { InventoryTeam } from './Inventory';
import { CreatingTeamModal, SetupTeamModal, ModalNotify, RevealRewardExpModal } from '../components/Modals';
import CountdownTimer from '../components/CountdownTimer';
import { ApisProvider, ExtinctionData, ExtinctionVideoData } from '../components/feactures/dataProvider';
import { useNavigate } from 'react-router-dom';
import { calculateItemStats } from '../components/feactures/dataIterator';
import { LayoutContainer, LayoutRow } from './layouts/layout_bi_columns';
import { motion } from 'framer-motion';
import { Hero } from '../components/Hero';


const rpcJs = new JsonRpc(ApisProvider.bdProvider);

export const InterExped = ({ userData, showLoader, closerLoader }) => {

    const [refreshComp, setRefreshComp] = useState();

    const [nofity, setNotify] = useState({
        status: false,
        error: false,
        title: '',
        msg: '',
        txId: '',
    })

    useEffect(() => {
        if(userData.isConnected){
            loadHeroData();
        }
    
      return () => {
        setHeroData({
            ownHero: false,
            hero_id: '',
            hero_templat_id: '',
        })
      }
    }, [refreshComp]);

    const [heroData, setHeroData] = useState({
        ownHero: false,
        hero_id: '',
        hero_templat_id: '',
    });

    useEffect(() => {
        if(userData.isConnected){
            loadHeroData();
        }
    
      return () => {
        
      }
    }, [userData.isConnected])
    

    const loadHeroData = async() => {
        const table = await rpcJs.get_table_rows({
            json: true,
            code: ExtinctionData.EXTINCTION_CONTRACT,
            scope: ExtinctionData.EXTINCTION_CONTRACT,
            table: ExtinctionData.TABLE_HEROES,
            lower_bound: userData.username,
            upper_bound: userData.username,
        });
        const {rows} = table
        const result = rows[0];

        if(result !== undefined){
            setHeroData({
                ownHero: true,
                hero_id: result.asset_id,
                hero_templat_id: result.template_id,
            })
        }
        
    }

    const selectHero = async(asset_id) => {
        if(userData.whichProvider === 'Anchor'){
            try{
                const action = {
                  account: ExtinctionData.EXTINCTION_CONTRACT,
                  name: 'sethero',
                  authorization: [userData.auths],
                  data: {
                    account: userData.username,
                    asset_ids: [asset_id],
                  },
                }
                userData.sessionData.transact({action}).then(({transaction}) => {
                //console.log(`Transaction broadcast! Id: ${transaction.id}`);
                setRefreshComp(transaction.id.toString());
                })
            }catch(err){
                
            }
        }
        else if(userData.whichProvider === 'WaxCloud'){
            try{
                const action = {
                    actions: [{
                      account: ExtinctionData.EXTINCTION_CONTRACT,
                        name: 'sethero',
                        authorization: [{
                            actor: userData.username,
                            permission: 'active',
                          }],
                        data: {
                            account: userData.username,
                            asset_ids: [asset_id],
                          },
                    }],
                }
                const transaction = await userData.sessionData.api.transact(action, {
                    blocksBehind: 3,
                    expireSeconds: 1200,
                  });
                  setNotify({
                    status: true,
                    error: false,
                    title: 'Success',
                    msg: 'Transaction Id:',
                    txId: transaction.transaction_id,
                  });
                  setRefreshComp(transaction.transaction_id);
              }
              catch(err){
                const msgError = err.message.split('assertion failure with message: ').join('')
                setNotify({
                    status: true,
                    error: true,
                    title: 'failed transaction',
                    msg: msgError,
                });
              }
        }
    }
    
    const navigate = useNavigate();

    const PushUrl = (url) => {
        navigate(url);
    }


    if(!userData.isConnected){
        return (
            <div className='signIn_box'>
                <h2 className='signIn-letter'>You need to sign in before!</h2>
            </div>
        )
    }

    if(showLoader){
        return (
          <div className='loader_animation'>
            <VideoLoader url={ExtinctionVideoData.loader} url2={ExtinctionVideoData.loaderMobile} autoClose={closerLoader}/>
          </div>
        )
    }

    return (
            <div className='container_lobby_expe'>
                {nofity.status && <ModalNotify notify={nofity} closeNotify={() => {
                setNotify({
                    status: false,
                    error: false,
                    title: '',
                    msg: '',
                    txId: '',
                })
              }}/>}
                <div className='main_box_lobby'>
                    <Hero userData={userData} dataHero={heroData} action={selectHero}/>
                    <div className='container_locations'>
                        <div className='title_container_locations'>
                            <motion.h2
                                initial={{opacity: 0, scale: 0}}
                                animate={{opacity: 1, scale: 1}}
                                transition={{duration: 0.3, delay: 0.2}}
                            >Choose the location</motion.h2>
                        </div>
                        <div className='main_flags_locations'>
                            <motion.div className='container_flags_locations'
                                initial={{opacity: 0, y: 100}}
                                animate={{opacity: 1, y: 0}}
                                transition={{duration: 0.3, delay: 0.4, type: 'tween'}}
                            >
                                <p className='text-center title-location'>Permafrost</p>
                                <div className='flag permafrost' onClick={() => PushUrl('/expeditions/permafrost')}>
                                    <img src="/img/logo-silkhs.png" alt="" />
                                </div>
                            </motion.div>
                            <motion.div className='container_flags_locations'
                                initial={{opacity: 0, y: 100}}
                                animate={{opacity: 1, y: 0}}
                                transition={{duration: 0.3, delay: 0.6, type: 'tween'}}>
                                <p className='text-center title-location'>Council City</p>
                                <div className='flag council-city' onClick={() => PushUrl('/expeditions/councilcity')}>
                                    <img src="/img/logo-cc.png" alt="" />
                                </div>
                            </motion.div>
                            <motion.div className='container_flags_locations'
                                initial={{opacity: 0, y: 100}}
                                animate={{opacity: 1, y: 0}}
                                transition={{duration: 0.3, delay: 0.7, type: 'tween'}}
                            >
                                <p className='text-center title-location'>Deserts Caves</p>
                                <div className='flag deserts-cave' onClick={() => PushUrl('/expeditions/desertscaves')}>
                                    <img src="/img/logo-arak.png" alt="" />
                                </div>
                            </motion.div>
                        </div>
                        <div className='trainingcamp_container_section'>
                            <button className='training_btn' onClick={() => PushUrl(`/expeditions/${ExtinctionData.LOCATION_ID_DUMMIES}`)}>Training Camp</button>
                        </div>
                    </div>
                </div>
            </div>
    )
}

export const Expedition = ({ userData, pricesFees, onRefreshBalances, showLoader, closerLoader }) => {
    
    const [authExp, setAuthExp] = useState();
    const [refreshComp, setRefreshComp] = useState(false);
    const [loadingData, setLoadingData] = useState(true);

    const [registered, setRegistered] = useState(false);
    const [risky, setRisky] = useState({
        status: false,
        slot_risky_1: 0,
        slot_risky_2: 0,
    });

    const [nofity, setNotify] = useState({
        status: false,
        error: false,
        title: '',
        msg: '',
        txId: '',
    })

    const {location} = useParams();

    useEffect(() => {
        if(userData.isConnected){
            loadAuthExp(location);
        }

        return () => {
            // Nothing
        };

    }, [refreshComp, userData.isConnected])

    const loadAuthExp = async(id) => {
        setLoadingData(true);
        if(id === ExtinctionData.LOCATION_ID_SILKHS){
            const table = await rpcJs.get_table_rows({
                json: true,
                code: ExtinctionData.EXTINCTION_CONTRACT,
                scope: ExtinctionData.EXTINCTION_CONTRACT,
                table: ExtinctionData.TABLE_SLOTS_SILKHS,
                lower_bound: userData.username,
                upper_bound: userData.username,
            });
            const {rows} = table
            const result = rows[0];
            if(result !== undefined){
                let slot1 = result.slot0;
                let slot2 = result.slot1;
                const setDataAuth = [slot1, slot2];
                setAuthExp(setDataAuth);
                setTimeout(() => {
                    setRegistered(true);
                    setLoadingData(false);
                }, 1000);
            }
            else {
                setLoadingData(false);
            }
        }
        else if(id === ExtinctionData.LOCATION_ID_ARAK){
            const table = await rpcJs.get_table_rows({
                json: true,
                code: ExtinctionData.EXTINCTION_CONTRACT,
                scope: ExtinctionData.EXTINCTION_CONTRACT,
                table: ExtinctionData.TABLE_SLOTS_ARAK,
                lower_bound: userData.username,
                upper_bound: userData.username,
            });
            const {rows} = table
            const result = rows[0];

            if(result !== undefined){
                let slot1 = result.slot0;
                let slot2 = result.slot1;
                const setDataAuth = [slot1, slot2];
                setAuthExp(setDataAuth);
                setTimeout(() => {
                    setRegistered(true);
                    setLoadingData(false);
                }, 1000);
            }
            else {
                setLoadingData(false);
            }
        }
        else if(id === ExtinctionData.LOCATION_ID_COUNCILC){
            const table = await rpcJs.get_table_rows({
                json: true,
                code: ExtinctionData.EXTINCTION_CONTRACT,
                scope: ExtinctionData.EXTINCTION_CONTRACT,
                table: ExtinctionData.TABLE_SLOTS_EXTRAS,
                lower_bound: userData.username,
                upper_bound: userData.username,
            });
            const {rows} = table
            const result = rows[0];
            if(result !== undefined){
                let slot1 = result.slot0;
                let slot2 = result.slot1;
                const setDataAuth = [slot1, slot2];
                setAuthExp(setDataAuth);
                setTimeout(() => {
                    setRegistered(true);
                    setLoadingData(false);
                }, 1000);
            }
            else {
                setLoadingData(false);
            }
        }
        else if(id === ExtinctionData.LOCATION_ID_DUMMIES){
            const table = await rpcJs.get_table_rows({
                json: true,
                code: ExtinctionData.EXTINCTION_CONTRACT,
                scope: ExtinctionData.EXTINCTION_CONTRACT,
                table: ExtinctionData.TABLE_SLOTS_DUMMIES,
                lower_bound: userData.username,
                upper_bound: userData.username,
            });

            const risky_table = await rpcJs.get_table_rows({
                json: true,
                code: ExtinctionData.EXTINCTION_CONTRACT,
                scope: ExtinctionData.EXTINCTION_CONTRACT,
                table: ExtinctionData.TABLE_SLOTS_RISKY,
                lower_bound: userData.username,
                upper_bound: userData.username,
            });
            const {rows} = table
            const result = rows[0];
            const result_risky = risky_table.rows[0];

            if(result !== undefined){
                let slot1 = result.slot0;
                let slot2 = result.slot1;
                const setDataAuth = [slot1, slot2];
                setAuthExp(setDataAuth);

                if(result_risky !== undefined){
                    setRisky({
                        status: true,
                        slot_risky_1: result_risky.risky0,
                        slot_risky_2: result_risky.risky1,
                    })
                }
                setTimeout(() => {
                    setRegistered(true);
                    setLoadingData(false);
                }, 1000);
            }
            else {
                setLoadingData(false);
            }
        }
    }

    const iniSltos = async() => {
        if(userData.whichProvider === 'Anchor'){
            try{
                const action = {
                  account: ExtinctionData.EXTINCTION_CONTRACT,
                  name: 'initslots',
                  authorization: [userData.auths],
                  data: {
                    account: userData.username,
                  },
                }
                userData.sessionData.transact({action}).then(({transaction}) => {
                //console.log(`Transaction broadcast! Id: ${transaction.id}`);
                setTimeout(() => {
                    setRefreshComp(transaction.id.toString());
                }, 1000);
                })
            }catch(err){
                
            }
        }
        else if(userData.whichProvider === 'WaxCloud'){
            try{
                const action = {
                    actions: [{
                        account:  ExtinctionData.EXTINCTION_CONTRACT,
                        name: 'initslots',
                        authorization: [{
                            actor: userData.username,
                            permission: 'active',
                          }],
                        data: {
                            account: userData.username,
                        },
                    }],
                }
                const transaction = await userData.sessionData.api.transact(action, {
                    blocksBehind: 3,
                    expireSeconds: 1200,
                  });
                  setNotify({
                    status: true,
                    error: false,
                    title: 'Success',
                    msg: 'Transaction Id:',
                    txId: transaction.transaction_id,
                  });
                  setTimeout(() => {
                    setRefreshComp(transaction.transaction_id);
                }, 1000);
              }
              catch(err){
                    const msgError = err.message.split('assertion failure with message: ').join('')
                    setNotify({
                        status: true,
                        error: true,
                        title: 'failed transaction',
                        msg: msgError,
                    });
              }
        }
    }

    const buyExtraSlot = async() => {
        if(userData.whichProvider === 'Anchor'){
            try{
                const action = {
                  account: ExtinctionData.ONYX_CONTRACT,
                  name: 'buyextraslot',
                  authorization: [userData.auths],
                  data: {
                    from: userData.username,
                    to: ExtinctionData.EXTINCTION_CONTRACT,
                    quantity: pricesFees.slotfee,
                    memo: 'Buy extraSlot',
                  },
                }
                userData.sessionData.transact({action}).then(({transaction}) => {
                //console.log(`Transaction broadcast! Id: ${transaction.id}`);
                setTimeout(() => {
                    onRefreshBalances();
                    setRefreshComp(transaction.id.toString());
                }, 1000);
                })
            }catch(err){
               
            }
        }
        else if(userData.whichProvider === 'WaxCloud'){
            try{
                const action = {
                    actions: [{
                        account: ExtinctionData.ONYX_CONTRACT,
                        name: 'buyextraslot',
                        authorization: [{
                            actor: userData.username,
                            permission: 'active',
                          }],
                        data: {
                            from: userData.username,
                            to: ExtinctionData.EXTINCTION_CONTRACT,
                            quantity: pricesFees.slotfee,
                            memo: 'Buy extraSlot',
                        },
                    }],
                }
                const transaction = await userData.sessionData.api.transact(action, {
                    blocksBehind: 3,
                    expireSeconds: 1200,
                  });
                  setNotify({
                    status: true,
                    error: false,
                    title: 'Success',
                    msg: 'Transaction Id:',
                    txId: transaction.transaction_id,
                  });
                  setTimeout(() => {
                    onRefreshBalances();
                    setRefreshComp(transaction.transaction_id);
                   }, 1000);
              }
              catch(err){
                    const msgError = err.message.split('assertion failure with message: ').join('')
                    setNotify({
                        status: true,
                        error: true,
                        title: 'failed transaction',
                        msg: msgError,
                    });
              }
        }
    }

    const navigate = useNavigate();

    const PushUrl = (url) => {
        navigate(url);
    }

    if(!userData.isConnected){
        return (
            <div className='signIn_box'>
                <h2 className='signIn-letter'>You need to sign in before!</h2>
            </div>
        )
    }

    if(showLoader){
        return (
          <div className='loader_animation'>
            <VideoLoader url={ExtinctionVideoData.loader} url2={ExtinctionVideoData.loaderMobile} autoClose={closerLoader}/>
          </div>
        )
    }

    if(loadingData){
        return (
            <div className='loading-box'>
                <div className="spinner-border">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        )
    }

    if(!registered){
        return (
            <div className='signIn_box'>
                <div className='d-flex flex-column'>
                    <h2 className='signIn-letter'>You need to register your expeditions!</h2>
                    <button className='btn_ btn-gen text-center' onClick={() => iniSltos()}>Register Expeditions</button>
                </div>
            </div>
        )
    }

    if(location === ExtinctionData.LOCATION_ID_SILKHS){
        return (
            <LayoutContainer styles_element={{backgroundColor: '#191819'}}>
                <LayoutRow>
                    <div className=''>
                        <button onClick={() => PushUrl('/expeditions')} className='backbtn'>Back</button>
                    </div>
                </LayoutRow>
                <div className='container-slots'>
                    {authExp.map((i, index) => (
                        <Slots key={index} idSlot={index} slotOwned={i} userData={userData} pricesFees={pricesFees} onRefreshBalances={onRefreshBalances} location={location}/>
                    ))}
                </div>
            </LayoutContainer>
        )
    }
    if(location === ExtinctionData.LOCATION_ID_ARAK){
        return (
            <LayoutContainer styles_element={{backgroundColor: '#191819'}}>
                <LayoutRow>
                    <div>
                        <button onClick={() => PushUrl('/expeditions')} className='backbtn'>Back</button>
                    </div>
                </LayoutRow>
                <div className='container-slots'>
                    {authExp.map((i, index) => (
                        <Slots key={index} idSlot={index + 2} slotOwned={i} userData={userData} pricesFees={pricesFees} onRefreshBalances={onRefreshBalances} location={location}/>
                    ))}
                </div>
            </LayoutContainer>
        )
    }

    if(location === ExtinctionData.LOCATION_ID_DUMMIES){
        return (
            <LayoutContainer styles_element={{backgroundColor: '#191819'}}>
                <LayoutRow>
                    <div>
                        <button onClick={() => PushUrl('/expeditions')} className='backbtn'>Back</button>
                    </div>
                </LayoutRow>
                <div className='container-slots'>
                    {authExp.map((i, index) => (
                        <Slots key={index} idSlot={index + 6} slotOwned={i} userData={userData} pricesFees={pricesFees} onRefreshBalances={onRefreshBalances} location={location} risky={risky}/>
                    ))}
                </div>
            </LayoutContainer>
        )
    }

    return (
        <>
        {nofity.status && <ModalNotify notify={nofity} closeNotify={() => {
                setNotify({
                    status: false,
                    error: false,
                    title: '',
                    msg: '',
                    txId: '',
                })
              }}/>}
        <LayoutContainer styles_element={{backgroundColor: '#191819'}}>
            <LayoutRow>
                <div>
                    <button onClick={() => PushUrl('/expeditions')} className='backbtn'>Back</button>
                </div>
            </LayoutRow>
            <div className='container-slots'>
                {authExp.map((i, index) => (
                    <Slots key={index} idSlot={index + 4} slotOwned={i} userData={userData} onPurchase={buyExtraSlot} pricesFees={pricesFees} onRefreshBalances={onRefreshBalances} location={location}/>
                ))}
            </div>
        </LayoutContainer>
        </>   
    )
}

export const Slots = ({ idSlot, userData, slotOwned, onPurchase, pricesFees, onRefreshBalances, location, risky }) => {

    const [emptySlot, setEmptySlot] = useState(true);
    const [dataTable, setDataTable] = useState();

    const [onExpedition, setOnExpedition] = useState(false);
    const [targetDateExpe, setTargetDateExpe] = useState();
    const [slotUbication, setSlotUbication] = useState();
    const [slotForPurshase, setSlotForPurchase] = useState(false);
    const [isRisky, setIsRisky] = useState(false);

    const [suitId, setSuitId] = useState();
    const [weaponId, setWeaponId] = useState();
    const [hasSuit, setHasSuit] = useState(false);
    const [hasWeapon, setHasWeapon] = useState(false);   
    
    const [creatingTeam, setCreatingTeam] = useState(false);
    const [setupTeam, setSetupTeam] = useState(false);
    const [revealRewardModal, setRevealRewardModal] = useState(false);
    
    const [refreshComp, setRefreshComp] = useState(false);

    useEffect(() => {
        
        if(userData.isConnected){
            loadtable();
        }

        return () => {
            //
        };

    }, [refreshComp])

    const [nofity, setNotify] = useState({
        status: false,
        error: false,
        title: '',
        msg: '',
        txId: '',
    })

    useEffect(() => {
        
        if(userData.isConnected){
            loadtable();
        }

        return () => {
            //
        };

    }, [userData.isConnected])


    const loadtable = async () => {
            setRefreshComp(false);
            if(slotOwned === 1){
                if(idSlot === 0){
                    setSlotUbication('Permafrost - North Pole');
                    const table = await rpcJs.get_table_rows({
                        json: true,
                        code: ExtinctionData.EXTINCTION_CONTRACT,
                        table: ExtinctionData.TABLE_EXPEDITIONS_00,
                        scope: ExtinctionData.EXTINCTION_CONTRACT,
                        lower_bound: userData.username,
                        upper_bound: userData.username,
                    });
                    const {rows} = table
                    const result = rows[0];
                    if(result !== undefined){
                        if(Number(result.teamexist) === 1){
                            setDataTable(result);
                            if(Number(result.hassuit) === 1){
                                setHasSuit(true);
                                const suit = result.suitid[0];
                                setSuitId(suit);
                            }
                            if(Number(result.haswep) === 1){
                                setHasWeapon(true);
                                const weapon = result.wepid[0];
                                setWeaponId(weapon);
                            }
                            if(Number(result.onexped) === 1){
                                const dateSet = result.exptime;
                                setOnExpedition(true);
                                
                                const timeToWait = 24 * 60 * 60 * 1000; // Milisegundos 24hrs
                                const expeDate = new Date(dateSet  + 'Z').getTime(); // Milisegundo
                                
                                const targetDateClaim = expeDate + timeToWait;
                                setTargetDateExpe(targetDateClaim);
                            }
                            setTimeout(setEmptySlot, 1000, false);
                        }
                    }else {
                
                    }
                }
                else if(idSlot === 1){
                    setSlotUbication('Permafrost - North Pole');
                    const table = await rpcJs.get_table_rows({
                        json: true,
                        code: ExtinctionData.EXTINCTION_CONTRACT,
                        table: ExtinctionData.TABLE_EXPEDITIONS_01,
                        scope: ExtinctionData.EXTINCTION_CONTRACT,
                        lower_bound: userData.username,
                        upper_bound: userData.username,
                    });
                    const {rows} = table
                    const result = rows[0];
                    if(result !== undefined){
                        if(Number(result.teamexist) === 1){
                            setDataTable(result);
                            if(Number(result.hassuit) === 1){
                                setHasSuit(true);
                                const suit = result.suitid[0];
                                setSuitId(suit);
                            }
                            if(Number(result.haswep) === 1){
                                setHasWeapon(true);
                                const weapon = result.wepid[0];
                                setWeaponId(weapon);
                            }
                            if(Number(result.onexped) === 1){
                                const dateSet = result.exptime;
                                
                                const timeToWait = 24 * 60 * 60 * 1000; // Milisegundos
                                const expeDate = new Date(dateSet  + 'Z').getTime();
                                
                                const targetDateClaim = expeDate + timeToWait;
                                setTargetDateExpe(targetDateClaim);
                                setTimeout(() => {
                                    setOnExpedition(true);
                                }, 500);
                                
                            }
                            setTimeout(setEmptySlot, 1000, false);
                        }
                    }
                    else {
                
                    }
                }else if(idSlot === 2){
                    setSlotUbication('Deserts Caves');
                    const table = await rpcJs.get_table_rows({
                        json: true,
                        code: ExtinctionData.EXTINCTION_CONTRACT,
                        table: ExtinctionData.TABLE_EXPEDITIONS_02,
                        scope: ExtinctionData.EXTINCTION_CONTRACT,
                        lower_bound: userData.username,
                        upper_bound: userData.username,
                    });
                    const {rows} = table
                    const result = rows[0];
                    if(result !== undefined){
                        if(Number(result.teamexist) === 1){
                            setDataTable(result);
                            if(Number(result.hassuit) === 1){
                                setHasSuit(true);
                                const suit = result.suitid[0];
                                setSuitId(suit);
                            }
                            if(Number(result.haswep) === 1){
                                setHasWeapon(true);
                                const weapon = result.wepid[0];
                                setWeaponId(weapon);
                            }
                            if(Number(result.onexped) === 1){
                                const dateSet = result.exptime;
                                
                                const timeToWait = 24 * 60 * 60 * 1000; // Milisegundos
                                const expeDate = new Date(dateSet  + 'Z').getTime(); 
                                
                                const targetDateClaim = expeDate + timeToWait;
                                setTargetDateExpe(targetDateClaim);
                                setTimeout(() => {
                                    setOnExpedition(true);
                                }, 500);
                            }
                            setTimeout(setEmptySlot, 1000, false);
                        }
                    }
                    else {
                
                    }
                }else if(idSlot === 3){
                    setSlotUbication('Deserts Caves');
                    const table = await rpcJs.get_table_rows({
                        json: true,
                        code: ExtinctionData.EXTINCTION_CONTRACT,
                        table: ExtinctionData.TABLE_EXPEDITIONS_03,
                        scope: ExtinctionData.EXTINCTION_CONTRACT,
                        lower_bound: userData.username,
                        upper_bound: userData.username,
                    });
                    const {rows} = table
                    const result = rows[0];
                    if(result !== undefined){
                        if(Number(result.teamexist) === 1){
                            setDataTable(result);
                            if(Number(result.hassuit) === 1){
                                setHasSuit(true);
                                const suit = result.suitid[0];
                                setSuitId(suit);
                            }
                            if(Number(result.haswep) === 1){
                                setHasWeapon(true);
                                const weapon = result.wepid[0];
                                setWeaponId(weapon);
                            }
                            if(Number(result.onexped) === 1){
                                const dateSet = result.exptime;
                                
                                const timeToWait = 24 * 60 * 60 * 1000; // Milisegundos
                                const expeDate = new Date(dateSet  + 'Z').getTime(); 
                                
                                const targetDateClaim = expeDate + timeToWait;
                                setTargetDateExpe(targetDateClaim);
                                setTimeout(() => {
                                    setOnExpedition(true);
                                }, 500);
                            }
                            setTimeout(setEmptySlot, 1000, false);
                        }
                    }
                    else {
                
                    }
                }
                else if(idSlot === 4){
                    setSlotUbication('Council City');
                    const table = await rpcJs.get_table_rows({
                        json: true,
                        code: ExtinctionData.EXTINCTION_CONTRACT,
                        table: ExtinctionData.TABLE_EXPEDITIONS_04,
                        scope: ExtinctionData.EXTINCTION_CONTRACT,
                        lower_bound: userData.username,
                        upper_bound: userData.username,
                    });
                    const {rows} = table
                    const result = rows[0];
                    if(result !== undefined){
                        if(Number(result.teamexist) === 1){
                            setDataTable(result);
                            if(Number(result.hassuit) === 1){
                                setHasSuit(true);
                                const suit = result.suitid[0];
                                setSuitId(suit);
                            }
                            if(Number(result.haswep) === 1){
                                setHasWeapon(true);
                                const weapon = result.wepid[0];
                                setWeaponId(weapon);
                            }
                            if(Number(result.onexped) === 1){
                                const dateSet = result.exptime;
                                
                                const timeToWait = 24 * 60 * 60 * 1000; // Milisegundos
                                const expeDate = new Date(dateSet  + 'Z').getTime(); 
                                
                                const targetDateClaim = expeDate + timeToWait;
                                setTargetDateExpe(targetDateClaim);
                                setTimeout(() => {
                                    setOnExpedition(true);
                                }, 500);
                            }
                            setTimeout(setEmptySlot, 1000, false);
                        }
                    }
                    else {
                
                    }
                }
                else if(idSlot === 5){
                    setSlotUbication('Council City');
                    const table = await rpcJs.get_table_rows({
                        json: true,
                        code: ExtinctionData.EXTINCTION_CONTRACT,
                        table: ExtinctionData.TABLE_EXPEDITIONS_05,
                        scope: ExtinctionData.EXTINCTION_CONTRACT,
                        lower_bound: userData.username,
                        upper_bound: userData.username,
                    });
                    const {rows} = table
                    const result = rows[0];
                    if(result !== undefined){
                        if(Number(result.teamexist) === 1){
                            setDataTable(result);
                            if(Number(result.hassuit) === 1){
                                setHasSuit(true);
                                const suit = result.suitid[0];
                                setSuitId(suit);
                            }
                            if(Number(result.haswep) === 1){
                                setHasWeapon(true);
                                const weapon = result.wepid[0];
                                setWeaponId(weapon);
                            }
                            if(Number(result.onexped) === 1){
                                const dateSet = result.exptime;
                                
                                const timeToWait = 24 * 60 * 60 * 1000; // Milisegundos
                                const expeDate = new Date(dateSet  + 'Z').getTime(); 
                                
                                const targetDateClaim = expeDate + timeToWait;
                                setTargetDateExpe(targetDateClaim);
                                setTimeout(() => {
                                    setOnExpedition(true);
                                }, 500);
                            }
                            setTimeout(setEmptySlot, 1000, false);
                        }
                    }
                    else {
                
                    }
                }
                else if(idSlot === 6){
                    setSlotUbication('Training Camp');
                    const table = await rpcJs.get_table_rows({
                        json: true,
                        code: ExtinctionData.EXTINCTION_CONTRACT,
                        table: ExtinctionData.TABLE_EXPEDITIONS_06,
                        scope: ExtinctionData.EXTINCTION_CONTRACT,
                        lower_bound: userData.username,
                        upper_bound: userData.username,
                    });
                    const {rows} = table
                    const result = rows[0];
                    if(result !== undefined){
                        if(Number(result.teamexist) === 1){
                            setDataTable(result);
                            if(Number(result.hassuit) === 1){
                                setHasSuit(true);
                                const suit = result.suitid[0];
                                setSuitId(suit);
                            }
                            if(Number(result.haswep) === 1){
                                setHasWeapon(true);
                                const weapon = result.wepid[0];
                                setWeaponId(weapon);
                            }
                            if(Number(result.onexped) === 1){
                                const dateSet = result.exptime;
                                
                                const timeToWait = pricesFees.traintime; // Milisegundos
                                
                                const expeDate = new Date(dateSet  + 'Z').getTime(); 
                                
                                const targetDateClaim = expeDate + timeToWait;
                                setTargetDateExpe(targetDateClaim);
                                setTimeout(() => {
                                    setOnExpedition(true);
                                }, 500);
                            }
                            setTimeout(setEmptySlot, 1000, false);
                        }
                    }
                    else {
                
                    }
                }
                else if(idSlot === 7){
                    setSlotUbication('Training Camp');
                    const table = await rpcJs.get_table_rows({
                        json: true,
                        code: ExtinctionData.EXTINCTION_CONTRACT,
                        table: ExtinctionData.TABLE_EXPEDITIONS_07,
                        scope: ExtinctionData.EXTINCTION_CONTRACT,
                        lower_bound: userData.username,
                        upper_bound: userData.username,
                    });
                    const {rows} = table
                    const result = rows[0];
                    if(result !== undefined){
                        if(Number(result.teamexist) === 1){
                            setDataTable(result);
                            if(Number(result.hassuit) === 1){
                                setHasSuit(true);
                                const suit = result.suitid[0];
                                setSuitId(suit);
                            }
                            if(Number(result.haswep) === 1){
                                setHasWeapon(true);
                                const weapon = result.wepid[0];
                                setWeaponId(weapon);
                            }
                            if(Number(result.onexped) === 1){
                                const dateSet = result.exptime;
                                
                                const timeToWait = pricesFees.traintime; // Milisegundos
                                
                                const expeDate = new Date(dateSet  + 'Z').getTime(); 
                                
                                const targetDateClaim = expeDate + timeToWait;
                                setTargetDateExpe(targetDateClaim);
                                setTimeout(() => {
                                    setOnExpedition(true);
                                }, 500);
                            }
                            setTimeout(setEmptySlot, 1000, false);
                        }
                    }
                    else {
                
                    }
                }
            }else{
                setSlotUbication('Council City');
                setSlotForPurchase(true);
            }
    }

    const openModalCreateTeam = () => {
        setCreatingTeam(true);
    }

    const closeCreateTeamModal = () => {
        setCreatingTeam(false);
    }
    const closeSetupTeamModal = () => {
        setSetupTeam(false);
    }

    const createTeam = async(id, teamName) => {
        if(userData.whichProvider === 'Anchor'){ 
            try{
                const action = {
                    account: ExtinctionData.EXTINCTION_CONTRACT,
                    name: 'createteam',
                    authorization: [userData.auths],
                    data: {
                    account: userData.username,
                    teamname: teamName,
                    slotid: id,
                    },
                }
                userData.sessionData.transact({action}).then(({transaction}) => {
                //console.log(`Transaction broadcast! Id: ${transaction.id}`);
                closeCreateTeamModal();
                setSetupTeam(true);
                })
            }catch(err){
        
            }
        }
        else if(userData.whichProvider === 'WaxCloud'){
            try{
                const action = {
                    actions: [{
                        account: ExtinctionData.EXTINCTION_CONTRACT,
                        name: 'createteam',
                        authorization: [{
                            actor: userData.username,
                            permission: 'active',
                          }],
                        data: {
                            account: userData.username,
                            teamname: teamName,
                            slotid: id,
                        },
                    }],
                }
                const transaction = await userData.sessionData.api.transact(action, {
                    blocksBehind: 3,
                    expireSeconds: 1200,
                  });
                  closeCreateTeamModal();
                    setSetupTeam(true);
              }
              catch(err){
                    const msgError = err.message.split('assertion failure with message: ').join('')
                    setNotify({
                        status: true,
                        error: true,
                        title: 'failed transaction',
                        msg: msgError,
                    });
              }
        }
    }

    const calculatePriceRisky = () => {
        const price = pricesFees.deployfee.split('.0000 ONYX').join('');
        const priceF = Number(price) * 4;
        return priceF;
    }

    const deployTeam = async(id) => {
        if(userData.whichProvider === 'Anchor'){
            try{
                const action = {
                  account: ExtinctionData.ONYX_CONTRACT,
                  name: 'deployteam',
                  authorization: [userData.auths],
                  data: {
                    from: userData.username,
                    to: ExtinctionData.EXTINCTION_CONTRACT,
                    quantity: `${id === 8 || id === 9 ? `${calculatePriceRisky()}.0000 ONYX` : pricesFees.deployfee}`,
                    slotid: id,
                  },
                }
                userData.sessionData.transact({action}).then(({transaction}) => {
                    //console.log(`Transaction broadcast! Id: ${transaction.id}`);
                    onRefreshBalances();
                    setOnExpedition(true);
                    setRefreshComp(transaction.id.toString());
                })
            }catch(err){

            }
        }
        else if(userData.whichProvider === 'WaxCloud'){
            try{
                const action = {
                    actions: [{
                        account: ExtinctionData.ONYX_CONTRACT,
                        name: 'deployteam',
                        authorization: [{
                            actor: userData.username,
                            permission: 'active',
                          }],
                        data: {
                            from: userData.username,
                            to: ExtinctionData.EXTINCTION_CONTRACT,
                            quantity: `${id === 8 || id === 9 ? `${calculatePriceRisky()}.0000 ONYX` : pricesFees.deployfee}`,
                            slotid: id,
                        },
                    }],
                }
                const transaction = await userData.sessionData.api.transact(action, {
                    blocksBehind: 3,
                    expireSeconds: 1200,
                  });
                  onRefreshBalances();
                  setRefreshComp(transaction.transaction_id);
                  setOnExpedition(true);
                  setNotify({
                    status: true,
                    error: false,
                    title: 'Success',
                    msg: 'Transaction Id:',
                    txId: transaction.transaction_id,
                  });
              }
              catch(err){
                    const msgError = err.message.split('assertion failure with message: ').join('')
                    setNotify({
                        status: true,
                        error: true,
                        title: 'failed transaction',
                        msg: msgError,
                    });
              }
        }
    }

    const claimTeam = async(id) => {
        if(userData.whichProvider === 'Anchor'){
            try{
                const action = {
                  account: ExtinctionData.EXTINCTION_CONTRACT,
                  name: 'claimexped',
                  authorization: [userData.auths],
                  data: {
                    account: userData.username,
                    slotid: id,
                  },
                }
                userData.sessionData.transact({action}).then(({transaction}) => {
                //console.log(`Transaction broadcast! Id: ${transaction.id}`);
                setOnExpedition(false);
                setRevealRewardModal(true);
                setTimeout(() => {
                    setRefreshComp(transaction.id.toString());
                }, 1000);
                })
            }catch(err){

            }
        }
        else if(userData.whichProvider === 'WaxCloud'){
            try{
                const action = {
                    actions: [{
                        account: ExtinctionData.EXTINCTION_CONTRACT,
                        name: 'claimexped',
                        authorization: [{
                            actor: userData.username,
                            permission: 'active',
                          }],
                        data: {
                            account: userData.username,
                            slotid: id,
                        },
                    }],
                }
                const transaction = await userData.sessionData.api.transact(action, {
                    blocksBehind: 3,
                    expireSeconds: 1200,
                  });
                    setOnExpedition(false);
                    setNotify({
                        status: true,
                        error: false,
                        title: 'Success',
                        msg: 'Transaction Id:',
                        txId: transaction.transaction_id,
                      });
                setRevealRewardModal(true);
                setTimeout(() => {
                    setRefreshComp(transaction.transaction_id);
                }, 1000);

              }
              catch(err){
                    const msgError = err.message.split('assertion failure with message: ').join('')
                    setNotify({
                        status: true,
                        error: true,
                        title: 'failed transaction',
                        msg: msgError,
                    });
              }
        }
        
    }

    const buyRisky = async() => {
        if(userData.whichProvider === 'Anchor'){
            try{
                const action = {
                  account: ExtinctionData.ONYX_CONTRACT,
                  name: 'buyextraslot',
                  authorization: [userData.auths],
                  data: {
                    from: userData.username,
                    to: ExtinctionData.EXTINCTION_CONTRACT,
                    quantity: pricesFees.slotfee,
                    memo: `Risky Expedition`,
                  },
                }
                userData.sessionData.transact({action}).then(({transaction}) => {
                //console.log(`Transaction broadcast! Id: ${transaction.id}`);
                setTimeout(() => {
                    onRefreshBalances();
                    setRefreshComp(transaction.id.toString());
                }, 500);
                })
            }catch(err){
               
            }
        }
        else if(userData.whichProvider === 'WaxCloud'){
            try{
                const action = {
                    actions: [{
                        account: ExtinctionData.ONYX_CONTRACT,
                        name: 'buyextraslot',
                        authorization: [{
                            actor: userData.username,
                            permission: 'active',
                          }],
                        data: {
                            from: userData.username,
                            to: ExtinctionData.EXTINCTION_CONTRACT,
                            quantity: pricesFees.slotfee,
                            memo: `Risky Expedition`,
                        },
                    }],
                }
                const transaction = await userData.sessionData.api.transact(action, {
                    blocksBehind: 3,
                    expireSeconds: 1200,
                  });
                  setNotify({
                    status: true,
                    error: false,
                    title: 'Success',
                    msg: 'Transaction Id:',
                    txId: transaction.transaction_id,
                  });
                  setTimeout(() => {
                    onRefreshBalances();
                    setRefreshComp(transaction.transaction_id);
                   }, 500);
              }
              catch(err){
                    const msgError = err.message.split('assertion failure with message: ').join('')
                    setNotify({
                        status: true,
                        error: true,
                        title: 'failed transaction',
                        msg: msgError,
                    });
              }
        }
        
    }

    const renderAgain = () => {
        closeSetupTeamModal();
        setRefreshComp(true);
    }

    const navigate = useNavigate();

    const PushUrl = (url) => {
        navigate(url);
    }

    if(Number(idSlot) === 6 || Number(idSlot) === 7){
        return (
            <>
        {nofity.status && <ModalNotify notify={nofity} closeNotify={() => {
                setNotify({
                    status: false,
                    error: false,
                    title: '',
                    msg: '',
                    txId: '',
                })
              }}/>}
        {setupTeam &&
            <SetupTeamModal closeModal={() => closeSetupTeamModal()} idSlot={idSlot} onLater={() => renderAgain()}/>
        }
        {creatingTeam &&
            <CreatingTeamModal closeModal={() => closeCreateTeamModal()} idSlot={idSlot} onCreate={createTeam}/>
        }
        {revealRewardModal && <RevealRewardExpModal closeModal={() => {
            setIsRisky(false);
            setRevealRewardModal(false);
        }} userData={userData} isRisky={isRisky}/>}
        {emptySlot
                        ? <motion.div className='slot_box'
                            initial={{opacity: 0, y: 100}}
                            animate={{opacity: 1, y: 0}}
                            transition={{duration: 0.3, delay: 0.4, type: 'tween'}}
                        >
                            
                            <div className='items_box'>
                                <div className='col'>
                                    <ItemEmpty/>
                                </div>
                                <div className='col'>
                                    <ItemEmpty/>
                                </div>
                            </div>
                            <div className='container-state-creator'>
                                <div>
                                    <p className='ubication text-center'>Location: {slotUbication}</p>
                                </div>
                                <div>
                                    <button onClick={() => openModalCreateTeam()} className='editteam_btn '>Create Team</button>
                                </div>
                            </div>
                        </motion.div>
                        : <div className='slot_box'
                            initial={{opacity: 0, y: 100}}
                            animate={{opacity: 1, y: 0}}
                            transition={{duration: 0.3, delay: 0.4, type: 'tween'}}
                            >

                            <div className='items_box'>
                                <div className='col'>
                                    <ItemsVertical id={suitId} hasItem={hasSuit}/>
                                </div>
                                <div className='col'>
                                    <ItemsVertical id={weaponId} hasItem={hasWeapon}/>
                                </div>
                            </div>
                            <div className='container-state-creator'>
                                <div className='info_team_slot'>
                                    <span>Team: {dataTable.teamname} </span>
                                    <p className='ubication'>Location: {slotUbication}</p>
                                </div>
                                <div className='footer_section_slots'>
                                    {onExpedition
                                        ?   <CountdownTimer targetDate={targetDateExpe} onClaim={claimTeam} idSlot={idSlot} risky={risky} setIsRisky={setIsRisky}/>
                                        :  <>
                                                {(hasSuit && hasWeapon) &&
                                                    <>
                                                        {risky.status
                                                            ? <button className='editteam_btn risky_btn' onClick={() => {
                                                                const id_risky = idSlot + 2;
                                                                deployTeam(id_risky)
                                                            }}>Deploy Risky</button>
                                                            : <button className='editteam_btn risky_btn' onClick={() => buyRisky()}>{`Unlock Risky: ${pricesFees.slotfee.split('.0000 ONYX').join('')} onyx`}</button>
                                                        }
                                                        <button className='editteam_btn alt_btn' onClick={() => deployTeam(idSlot)}>Deploy</button>
                                                    </>
                                                }
                                                <button onClick={() => PushUrl(`editteam/${idSlot}`)}className='editteam_btn'>View Team</button>
                                                </>
                                    }
                                </div>
                            </div>
                        </div>         

                    }
        </>
        )
    }

    return (
        <>
        {nofity.status && <ModalNotify notify={nofity} closeNotify={() => {
                setNotify({
                    status: false,
                    error: false,
                    title: '',
                    msg: '',
                    txId: '',
                })
              }}/>}
        {setupTeam &&
            <SetupTeamModal closeModal={() => closeSetupTeamModal()} idSlot={idSlot} onLater={() => renderAgain()}/>
        }
        {creatingTeam &&
            <CreatingTeamModal closeModal={() => closeCreateTeamModal()} idSlot={idSlot} onCreate={createTeam}/>
        }
        {revealRewardModal && <RevealRewardExpModal closeModal={() => setRevealRewardModal(false)} userData={userData}/>}
        {slotForPurshase
            ?   <motion.div className='slot_box'
                    initial={{opacity: 0, y: 100}}
                    animate={{opacity: 1, y: 0}}
                    transition={{duration: 0.3, delay: 0.4, type: 'tween'}}
                >
                    <div className='col items_box'>
                        <div className='col'>
                            <ItemEmpty/>
                        </div>
                        <div className='col'>
                            <ItemEmpty/>
                        </div>
                    </div>
                    <div className='col container-state-creator'>
                        <div>
                            <p className='ubication text-center'>Location: {slotUbication}</p>
                        </div>
                        <div>
                            <button className='editteam_btn' onClick={() => onPurchase()}>Purchase Now</button>
                        </div>
                    </div>
                </motion.div>
            :   <>
                    {emptySlot
                        ? <motion.div className='slot_box'
                            initial={{opacity: 0, y: 100}}
                            animate={{opacity: 1, y: 0}}
                            transition={{duration: 0.3, delay: 0.4, type: 'tween'}}
                        >
                            
                            <div className='items_box'>
                                <div className='col'>
                                    <ItemEmpty/>
                                </div>
                                <div className='col'>
                                    <ItemEmpty/>
                                </div>
                            </div>
                            <div className='container-state-creator'>
                                <div>
                                    <p className='ubication text-center'>Location: {slotUbication}</p>
                                </div>
                                <div>
                                    <button onClick={() => openModalCreateTeam()} className='editteam_btn '>Create Team</button>
                                </div>
                            </div>
                        </motion.div>
                        : <div className='slot_box'
                            initial={{opacity: 0, y: 100}}
                            animate={{opacity: 1, y: 0}}
                            transition={{duration: 0.3, delay: 0.4, type: 'tween'}}
                            >

                            <div className='items_box'>
                                <div className='col'>
                                    <ItemsVertical id={suitId} hasItem={hasSuit}/>
                                </div>
                                <div className='col'>
                                    <ItemsVertical id={weaponId} hasItem={hasWeapon}/>
                                </div>
                            </div>
                            <div className='container-state-creator'>
                                <div className='info_team_slot'>
                                    <span>Team: {dataTable.teamname} </span>
                                    <p className='ubication'>Location: {slotUbication}</p>
                                </div>
                                <div className='footer_section_slots'>
                                    {onExpedition
                                        ?   <CountdownTimer targetDate={targetDateExpe} onClaim={claimTeam} idSlot={idSlot}/>
                                        :  <>
                                                {(hasSuit && hasWeapon) &&
                                                    <button className='editteam_btn alt_btn' onClick={() => deployTeam(idSlot)}>Deploy</button>
                                                }
                                                <button onClick={() => PushUrl(`editteam/${idSlot}`)}className='editteam_btn'>View Team</button>
                                                </>
                                    }
                                </div>
                            </div>
                        </div>

                    }            
                </>

        }
        </>
    )
}

export const EditTeam = ({ userData, showLoader, closerLoader, onRefreshBalances, pricesFees }) => {

    const [loadingData, setLoadingData] = useState(true);
    const [refreshComp, setRefreshComp] = useState(false);
    const [dataTable, setDataTable] = useState();
    const [onExpedition, setOnExpedition] = useState(false);
    
    const [hasSuit, setHasSuit] = useState(false);
    const [suitId, setSuitId] = useState();
    const [suitSelected, setSuitSelected] = useState(false);
    const [idSuitSelected, setIdSuitSelected] = useState();
    
    
    const [weaponId, setWeaponId] = useState();
    const [hasWeapon, setHasWeapon] = useState(false);
    const [weaponSelected, setWeaponSelected] = useState(false);
    const [idWeaponSelected, setIdWeaponSelected] = useState();
    const [suitStatistics, setSuitStatistics] = useState({
        power: 0,
        wightLimit: 0,
        radiationRes: 0,
        energyC: 0,
    })
    const [weaponStatistics, setWeaponStatistics] = useState({
        power: 0,
        utility: 0,
        lethality: 0,
        attack: 0,
    })

    const [teamDeleted, setTeamDeleted] = useState();

    const [nofity, setNotify] = useState({
        status: false,
        error: false,
        title: '',
        msg: '',
        txId: '',
    })

    const {id} = useParams();
    const location = id;

    useEffect(() => {
        if(userData.isConnected){
            loadTeam(location);
        }

        return () => {
            //
        };

    }, [refreshComp, userData.isConnected]);

    const tPower = Number(suitStatistics.power) + Number(weaponStatistics.power);
    const tEff = ((Number(suitStatistics.wightLimit) + Number(weaponStatistics.utility))/190)*100;
    const tStr = (((Number(suitStatistics.radiationRes) + Number(suitStatistics.energyC)) + (Number(weaponStatistics.lethality) + Number(weaponStatistics.attack)))/300)*100;

    const calculatePriceRisky = () => {
        const price = pricesFees.deployfee.split('.0000 ONYX').join('');
        const priceF = Number(price) * 4;
        return priceF;
    }
    

    const rewarder = (power) => {
        if(Number(power) >= 200 && Number(power) <= 319){
            const reward = {
                text: 'Common Reward Box',
                style: 'box_common',
            }
            return reward;
        }
        else if(Number(power) >= 320 && Number(power) <= 529){
            const reward = {
                text: 'Rare Reward Box',
                style: 'box_rare',
            }
            return reward;
        }
        else if(Number(power) >= 530 && Number(power) <= 799){
            const reward = {
                text: 'Epic Reward Box',
                style: 'box_epic',
            }
            return reward;
        }
        else if(Number(power) >= 800){
            const reward = {
                text: 'Legendary Reward Box',
                style: 'box_legendary',
            }
            return reward;
        }
        else if(Number(power) === 80){
            const reward = {
                text: 'Training Reward Box',
                style: 'box_common',
            }
            return reward;
        }
        else {
            const reward = {
                text: 'No Reward',
                style: 'box_noreward',
            }
            return reward;
        }
    }

    const calcReward = rewarder(tPower);

    const loadStatistics = async(id) => {
        const api = `${ApisProvider.atomicApi}atomicassets/v1/assets/${id}`;
        const response = await fetch(api, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Origin': '*'
            }
        });
        const data = await response.json();
        const itemData = data.data;
        const rarity = itemData.data.Rarity;
        const power = itemData.data.Power;
        const itemType = itemData.schema.schema_name;
        const nation = itemData.data.Nation;

        if(itemType === 'suits'){
            const stats = calculateItemStats(rarity, power, itemType, nation);
            setSuitStatistics({
                power: power,
                wightLimit: stats.weightL,
                radiationRes: stats.radiationR,
                energyC: stats.energyC,
            })
        }
        else if(itemType === 'weapons'){
            const stats = calculateItemStats(rarity, power, itemType, nation);
            setWeaponStatistics({
                power: power,
                utility: stats.utility,
                lethality: stats.lethality,
                attack: stats.attack,
            })
        }
        
    }

    const loadTeam = async(id) => {
            setLoadingData(true);
            if(Number(id) === 0){
                const table = await rpcJs.get_table_rows({
                    json: true,
                    code: ExtinctionData.EXTINCTION_CONTRACT,
                    table: ExtinctionData.TABLE_EXPEDITIONS_00,
                    scope: ExtinctionData.EXTINCTION_CONTRACT,
                    lower_bound: userData.username,
                    upper_bound: userData.username,
                });
                const {rows} = table
                const result = rows[0];
                if(Number(result.teamexist) === 1){
                    setDataTable(result);
                    if(Number(result.hassuit) === 1){
                        setHasSuit(true);
                        const suit = result.suitid[0];
                        setSuitId(suit);
                        loadStatistics(suit);
                    }
                    if(Number(result.haswep) === 1){
                        setHasWeapon(true);
                        const weapon = result.wepid[0];
                        setWeaponId(weapon);
                        loadStatistics(weapon);
                    }
                    if(Number(result.onexp) === 1){
                        setOnExpedition(true);
                    }
                    setTimeout(setLoadingData, 1000, false)
                }
            }else if(Number(id) === 1){
                const table = await rpcJs.get_table_rows({
                    json: true,
                    code: ExtinctionData.EXTINCTION_CONTRACT,
                    table: ExtinctionData.TABLE_EXPEDITIONS_01,
                    scope: ExtinctionData.EXTINCTION_CONTRACT,
                    lower_bound: userData.username,
                    upper_bound: userData.username,
                });
                const {rows} = table
                const result = rows[0];
                if(Number(result.teamexist) === 1){
                    setDataTable(result);
                    if(Number(result.hassuit) === 1){
                        setHasSuit(true);
                        const suit = result.suitid[0];
                        setSuitId(suit);
                        loadStatistics(suit);
                    }
                    if(Number(result.haswep) === 1){
                        setHasWeapon(true);
                        const weapon = result.wepid[0];
                        setWeaponId(weapon);
                        loadStatistics(weapon);
                    }
                    if(Number(result.onexp) === 1){
                        setOnExpedition(true);
                    }
                    setTimeout(setLoadingData, 1000, false)
                }
            }else if(Number(id) === 2){
                const table = await rpcJs.get_table_rows({
                    json: true,
                    code: ExtinctionData.EXTINCTION_CONTRACT,
                    table: ExtinctionData.TABLE_EXPEDITIONS_02,
                    scope: ExtinctionData.EXTINCTION_CONTRACT,
                    lower_bound: userData.username,
                    upper_bound: userData.username,
                });
                const {rows} = table
                const result = rows[0];
                if(Number(result.teamexist) === 1){
                    setDataTable(result);
                    if(Number(result.hassuit) === 1){
                        setHasSuit(true);
                        const suit = result.suitid[0];
                        setSuitId(suit);
                        loadStatistics(suit);

                    }
                    if(Number(result.haswep) === 1){
                        setHasWeapon(true);
                        const weapon = result.wepid[0];
                        setWeaponId(weapon);
                        loadStatistics(weapon);
                    }
                    if(Number(result.onexp) === 1){
                        setOnExpedition(true);
                    }
                    setTimeout(setLoadingData, 1000, false)
                }
            }else if(Number(id) === 3){
                const table = await rpcJs.get_table_rows({
                    json: true,
                    code: ExtinctionData.EXTINCTION_CONTRACT,
                    table: ExtinctionData.TABLE_EXPEDITIONS_03,
                    scope: ExtinctionData.EXTINCTION_CONTRACT,
                    lower_bound: userData.username,
                    upper_bound: userData.username,
                });
                const {rows} = table
                const result = rows[0];
                if(Number(result.teamexist) === 1){
                    setDataTable(result);
                    if(Number(result.hassuit) === 1){
                        setHasSuit(true);
                        const suit = result.suitid[0];
                        setSuitId(suit);
                        loadStatistics(suit);
                    }
                    if(Number(result.haswep) === 1){
                        setHasWeapon(true);
                        const weapon = result.wepid[0];
                        setWeaponId(weapon);
                        loadStatistics(weapon);
                    }
                    if(Number(result.onexp) === 1){
                        setOnExpedition(true);
                    }
                    setTimeout(setLoadingData, 1000, false)
                }
            }else if(Number(id) === 4){
                const table = await rpcJs.get_table_rows({
                    json: true,
                    code: ExtinctionData.EXTINCTION_CONTRACT,
                    table: ExtinctionData.TABLE_EXPEDITIONS_04,
                    scope: ExtinctionData.EXTINCTION_CONTRACT,
                    lower_bound: userData.username,
                    upper_bound: userData.username,
                });
                const {rows} = table
                const result = rows[0];
                if(Number(result.teamexist) === 1){
                    setDataTable(result);
                    if(Number(result.hassuit) === 1){
                        setHasSuit(true);
                        const suit = result.suitid[0];
                        setSuitId(suit);
                        loadStatistics(suit);
                    }
                    if(Number(result.haswep) === 1){
                        setHasWeapon(true);
                        const weapon = result.wepid[0];
                        setWeaponId(weapon);
                        loadStatistics(weapon);
                    }
                    if(Number(result.onexp) === 1){
                        setOnExpedition(true);
                    }
                    setTimeout(setLoadingData, 1000, false)
                }
            }else if(Number(id) === 5){
                const table = await rpcJs.get_table_rows({
                    json: true,
                    code: ExtinctionData.EXTINCTION_CONTRACT,
                    table: ExtinctionData.TABLE_EXPEDITIONS_05,
                    scope: ExtinctionData.EXTINCTION_CONTRACT,
                    lower_bound: userData.username,
                    upper_bound: userData.username,
                });
                const {rows} = table
                const result = rows[0];
                if(Number(result.teamexist) === 1){
                    setDataTable(result);
                    if(Number(result.hassuit) === 1){
                        setHasSuit(true);
                        const suit = result.suitid[0];
                        setSuitId(suit);
                        loadStatistics(suit);
                    }
                    if(Number(result.haswep) === 1){
                        setHasWeapon(true);
                        const weapon = result.wepid[0];
                        setWeaponId(weapon);
                        loadStatistics(weapon);
                    }
                    if(Number(result.onexp) === 1){
                        setOnExpedition(true);
                    }
                    setTimeout(setLoadingData, 1000, false)
                }
            }
            else if(Number(id) === 6){
                const table = await rpcJs.get_table_rows({
                    json: true,
                    code: ExtinctionData.EXTINCTION_CONTRACT,
                    table: ExtinctionData.TABLE_EXPEDITIONS_06,
                    scope: ExtinctionData.EXTINCTION_CONTRACT,
                    lower_bound: userData.username,
                    upper_bound: userData.username,
                });
                const {rows} = table
                const result = rows[0];

                if(Number(result.teamexist) === 1){
                    setDataTable(result);
                    if(Number(result.hassuit) === 1){
                        setHasSuit(true);
                        const suit = result.suitid[0];
                        setSuitId(suit);
                        loadStatistics(suit);
                    }
                    if(Number(result.haswep) === 1){
                        setHasWeapon(true);
                        const weapon = result.wepid[0];
                        setWeaponId(weapon);
                        loadStatistics(weapon);
                    }
                    if(Number(result.onexp) === 1){
                        setOnExpedition(true);
                    }
                    setTimeout(setLoadingData, 1000, false)
                }
            }else if(Number(id) === 7){
                const table = await rpcJs.get_table_rows({
                    json: true,
                    code: ExtinctionData.EXTINCTION_CONTRACT,
                    table: ExtinctionData.TABLE_EXPEDITIONS_07,
                    scope: ExtinctionData.EXTINCTION_CONTRACT,
                    lower_bound: userData.username,
                    upper_bound: userData.username,
                });
                const {rows} = table
                const result = rows[0];
                if(Number(result.teamexist) === 1){
                    setDataTable(result);
                    if(Number(result.hassuit) === 1){
                        setHasSuit(true);
                        const suit = result.suitid[0];
                        setSuitId(suit);
                        loadStatistics(suit);
                    }
                    if(Number(result.haswep) === 1){
                        setHasWeapon(true);
                        const weapon = result.wepid[0];
                        setWeaponId(weapon);
                        loadStatistics(weapon);
                    }
                    if(Number(result.onexp) === 1){
                        setOnExpedition(true);
                    }
                    setTimeout(setLoadingData, 1000, false)
                }
            }
    }

    const deleteTeam = async() => {
        if(userData.whichProvider === 'Anchor'){
            try{
                const action = {
                  account: ExtinctionData.EXTINCTION_CONTRACT,
                  name: 'deleteteam',
                  authorization: [userData.auths],
                  data: {
                    account: userData.username,
                    slotid: id,
                  },
                }
                userData.sessionData.transact({action}).then(({transaction}) => {
                //console.log(`Transaction broadcast! Id: ${transaction.id}`);
                setTeamDeleted(true);
                })
            }
            catch(err){
                
            }
        }
        else if(userData.whichProvider === 'WaxCloud'){
            try{
                const action = {
                    actions: [{
                        account: ExtinctionData.EXTINCTION_CONTRACT,
                        name: 'deleteteam',
                        authorization: [{
                            actor: userData.username,
                            permission: 'active',
                          }],
                        data: {
                            account: userData.username,
                            slotid: id,
                        },
                    }],
                }
                const transaction = await userData.sessionData.api.transact(action, {
                    blocksBehind: 3,
                    expireSeconds: 1200,
                  });
                  setTeamDeleted(true);
              }
              catch(err){
                    const msgError = err.message.split('assertion failure with message: ').join('')
                    setNotify({
                        status: true,
                        error: true,
                        title: 'failed transaction',
                        msg: msgError,
                    });
              }
        }
    }

    const recoverSuit = async() => {
        if(userData.whichProvider === 'Anchor'){
            try{
                const action = {
                  account: ExtinctionData.EXTINCTION_CONTRACT,
                  name: 'recoversuit',
                  authorization: [userData.auths],
                  data: {
                    account: userData.username,
                    slotid: id,
                  },
                }
                userData.sessionData.transact({action}).then(({transaction}) => {
                //console.log(`Transaction broadcast! Id: ${transaction.id}`);
                    setIdSuitSelected('');
                    setSuitSelected(false);
                    setHasSuit(false);
                    setSuitId('');
                })
            }
            catch(err){
                
            }
        }
        else if(userData.whichProvider === 'WaxCloud'){
            try{
                const action = {
                    actions: [{
                        account: ExtinctionData.EXTINCTION_CONTRACT,
                        name: 'recoversuit',
                        authorization: [{
                            actor: userData.username,
                            permission: 'active',
                          }],
                        data: {
                            account: userData.username,
                            slotid: id,
                        },
                    }],
                }
                const transaction = await userData.sessionData.api.transact(action, {
                    blocksBehind: 3,
                    expireSeconds: 1200,
                  });
                  setNotify({
                    status: true,
                    error: false,
                    title: 'Success',
                    msg: 'Transaction Id:',
                    txId: transaction.transaction_id,
                  });
                  setIdSuitSelected('');
                  setSuitSelected(false);
                  setHasSuit(false);
                  setSuitId('');

              }
              catch(err){
                    const msgError = err.message.split('assertion failure with message: ').join('')
                    setNotify({
                        status: true,
                        error: true,
                        title: 'failed transaction',
                        msg: msgError,
                    });
              }
        }
        
    }

    const addSuit = async() => {
        if(userData.whichProvider === 'Anchor'){
            try{
                const action = {
                    account: 'atomicassets',
                    name: 'transfer',
                    authorization: [userData.auths],
                    data: {
                      from: userData.username,
                      to: ExtinctionData.EXTINCTION_CONTRACT,
                      asset_ids: [idSuitSelected],
                      memo: `Add Suit Slot ${id}`,
                    },
                }
                userData.sessionData.transact({action}).then(({transaction}) => {
                //console.log(`Transaction broadcast! Id: ${transaction.id}`);
                setSuitId(idSuitSelected);
                setHasSuit(true);

                })
            }
            catch(err){
                
            }
        }
        else if(userData.whichProvider === 'WaxCloud'){
            try{
                const action = {
                    actions: [{
                        account: 'atomicassets',
                        name: 'transfer',
                        authorization: [{
                            actor: userData.username,
                            permission: 'active',
                          }],
                        data: {
                            from: userData.username,
                            to: ExtinctionData.EXTINCTION_CONTRACT,
                            asset_ids: [idSuitSelected],
                            memo: `Add Suit Slot ${id}`,
                        },
                    }],
                }
                const transaction = await userData.sessionData.api.transact(action, {
                    blocksBehind: 3,
                    expireSeconds: 1200,
                  });
                  setNotify({
                    status: true,
                    error: false,
                    title: 'Success',
                    msg: 'Transaction Id:',
                    txId: transaction.transaction_id,
                  });
                    setSuitId(idSuitSelected);
                    setHasSuit(true);
              }
              catch(err){
                    const msgError = err.message.split('assertion failure with message: ').join('')
                    setNotify({
                        status: true,
                        error: true,
                        title: 'failed transaction',
                        msg: msgError,
                    });
              }
        }
        
    }

    const addWeapon = async() => {
        if(userData.whichProvider === 'Anchor'){
            try{
                const action = {
                    account: 'atomicassets',
                    name: 'transfer',
                    authorization: [userData.auths],
                    data: {
                      from: userData.username,
                      to: ExtinctionData.EXTINCTION_CONTRACT,
                      asset_ids: [idWeaponSelected],
                      memo: `Add Wep Slot ${id}`,
                    },
                }
                userData.sessionData.transact({action}).then(({transaction}) => {
                //console.log(`Transaction broadcast! Id: ${transaction.id}`);
                setWeaponId(idWeaponSelected);
                setHasWeapon(true);
                })
            }
            catch(err){
            
            }
        }
        else if(userData.whichProvider === 'WaxCloud'){
            try{
                const action = {
                    actions: [{
                        account: 'atomicassets',
                        name: 'transfer',
                        authorization: [{
                            actor: userData.username,
                            permission: 'active',
                          }],
                        data: {
                            from: userData.username,
                            to: ExtinctionData.EXTINCTION_CONTRACT,
                            asset_ids: [idWeaponSelected],
                            memo: `Add Wep Slot ${id}`,
                        },
                    }],
                }
                const transaction = await userData.sessionData.api.transact(action, {
                    blocksBehind: 3,
                    expireSeconds: 1200,
                  });
                  setNotify({
                    status: true,
                    error: false,
                    title: 'Success',
                    msg: 'Transaction Id:',
                    txId: transaction.transaction_id,
                  });
                  setWeaponId(idWeaponSelected);
                setHasWeapon(true);
                
              }
              catch(err){
                    const msgError = err.message.split('assertion failure with message: ').join('')
                    setNotify({
                        status: true,
                        error: true,
                        title: 'failed transaction',
                        msg: msgError,
                    });
              }
        }
        
    }

    const recoverWeapon = async() => {
        if(userData.whichProvider === 'Anchor'){
            try{
                const action = {
                  account: ExtinctionData.EXTINCTION_CONTRACT,
                  name: 'recoverwep',
                  authorization: [userData.auths],
                  data: {
                    account: userData.username,
                    slotid: id,
                  },
                }
                userData.sessionData.transact({action}).then(({transaction}) => {
                //console.log(`Transaction broadcast! Id: ${transaction.id}`);
                setIdWeaponSelected('');
                setWeaponSelected(false);
                setHasWeapon(false);
                setWeaponId('');
                })
            }
            catch(err){
               
            }
        }
        else if(userData.whichProvider === 'WaxCloud'){
            try{
                const action = {
                    actions: [{
                        account: ExtinctionData.EXTINCTION_CONTRACT,
                        name: 'recoverwep',
                        authorization: [{
                            actor: userData.username,
                            permission: 'active',
                          }],
                        data: {
                            account: userData.username,
                            slotid: id,
                        },
                    }],
                }
                const transaction = await userData.sessionData.api.transact(action, {
                    blocksBehind: 3,
                    expireSeconds: 1200,
                  });
                  setNotify({
                    status: true,
                    error: false,
                    title: 'Success',
                    msg: 'Transaction Id:',
                    txId: transaction.transaction_id,
                  });
                  setIdWeaponSelected('');
                setWeaponSelected(false);
                setHasWeapon(false);
                setWeaponId('');
    
              }
              catch(err){
                    const msgError = err.message.split('assertion failure with message: ').join('')
                    setNotify({
                        status: true,
                        error: true,
                        title: 'failed transaction',
                        msg: msgError,
                    });
              }
        }
        
    }

    const selectorItem = (id, itemId) => {
        if(id === 'suits'){
            setIdSuitSelected(itemId);
            setSuitSelected(true);
            loadStatistics(itemId);
        }
        else if(id === 'weapons'){
            setIdWeaponSelected(itemId);
            setWeaponSelected(true);
            loadStatistics(itemId);
        }
    }

    const deployTeam = async(id) => {
        if(userData.whichProvider === 'Anchor'){
            try{
                const action = {
                  account: ExtinctionData.ONYX_CONTRACT,
                  name: 'deployteam',
                  authorization: [userData.auths],
                  data: {
                    from: userData.username,
                    to: ExtinctionData.EXTINCTION_CONTRACT,
                    quantity: `${id === 8 || id === 9 ? `${calculatePriceRisky()}.0000 ONYX` : pricesFees.deployfee}`,
                    slotid: id,
                  },
                }
                userData.sessionData.transact({action}).then(({transaction}) => {
                    //console.log(`Transaction broadcast! Id: ${transaction.id}`);
                    setOnExpedition(true);
                    onRefreshBalances();
                })
            }catch(err){
                
            }
        }
        else if(userData.whichProvider === 'WaxCloud'){
            try{
                const action = {
                    actions: [{
                        account: ExtinctionData.ONYX_CONTRACT,
                        name: 'deployteam',
                        authorization: [{
                            actor: userData.username,
                            permission: 'active',
                          }],
                        data: {
                            from: userData.username,
                            to: ExtinctionData.EXTINCTION_CONTRACT,
                            quantity: `${id === 8 || id === 9 ? `${calculatePriceRisky()}.0000 ONYX` : pricesFees.deployfee}`,
                            slotid: id,
                        },
                    }],
                }
                const transaction = await userData.sessionData.api.transact(action, {
                    blocksBehind: 3,
                    expireSeconds: 1200,
                  });
                    setOnExpedition(true);
                    onRefreshBalances();
              }
              catch(err){
                    const msgError = err.message.split('assertion failure with message: ').join('')
                    setNotify({
                        status: true,
                        error: true,
                        title: 'failed transaction',
                        msg: msgError,
                    });
              }
        }
        
    }

    const navigate = useNavigate();
  
    const BackUrl = () => {
        navigate(-1);
    }
    

    if(!userData.isConnected){
        return (
            <div className='signIn_box'>
                <h2 className='signIn-letter'>You need to sign in before!</h2>
            </div>
        )
    }

    if(loadingData){
        return (
            <div className='loading-box'>
                <div className="spinner-border">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        )
    }

    if(showLoader){
        return (
          <div className='loader_animation'>
            <VideoLoader url={ExtinctionVideoData.loader} url2={ExtinctionVideoData.loaderMobile} autoClose={closerLoader}/>
          </div>
        )
    }

    if(teamDeleted){
        return (
            <div className='deployed_section_contatiner'>
                <div className='content_box_deployed'>
                    <h2 className=''>The team was deleted!</h2>
                    <button onClick={() => BackUrl()} className=''>Back</button>
                </div>
            </div>  
        )
    }

    if(onExpedition){
        return (
            <div className='deployed_section_contatiner'>
                <div className='content_box_deployed'>
                    <h2 className=''>Your team was deployed successful!</h2>
                    <button onClick={() => BackUrl()} className=''>Back</button>
                </div>
            </div>  
        )
    }

    if(Number(location) === 6 || Number(location) === 7){
        return(
            <> <LayoutContainer styles_element={{overflow: 'auto', backgroundColor: '#191819'}}>
                    <div style={{width: '100%', display: 'flex', justifyContent: 'center'}}>
                  {nofity.status && <ModalNotify notify={nofity} closeNotify={() => {
                            setNotify({
                                status: false,
                                error: false,
                                title: '',
                                msg: '',
                                txId: '',
                            })
                          }}/>}
                  </div>
                        <button onClick={() => BackUrl()} className='backbtn'>Back</button>
                        <div className='title-box-edit-team'>
                            <h2 className='text-center'>Team Name: {dataTable.teamname}</h2>
                        </div>
                        <div className=''>
                            <div className="header-edit-team-box">
                                <div className="items_box_edit">
                                    <div className="">
                                        {hasSuit
                                            ?   <ItemsVertical id={suitId} hasItem={hasSuit}/>
                                            : <>{suitSelected
                                                    ?  <ItemsVertical id={idSuitSelected} hasItem={suitSelected}/>
                                                    :  <ItemEmpty/>
                                                }
                                                </>
                                        }
                                    </div>
                                    <div className="">
                                        {hasWeapon
                                                ?   <ItemsVertical id={weaponId} hasItem={hasWeapon}/>
                                                : <>{weaponSelected
                                                        ?  <ItemsVertical id={idWeaponSelected} hasItem={weaponSelected}/>
                                                        :   <ItemEmpty/>
                                                    }
                                                    </>
                                        }
                                    </div>
                                </div>
                                <div className='statistics_actions_box'>
                                    <div className="box-statistics">
                                        <h3>Team Statistics</h3>
                                        <div className='box_progressbar_statistics'>
                                            <div className='box_progressbar'>
                                                <div className='stats_performance_container'>
                                                    <h4>Team Power: {tPower}</h4>
                                                    <div className='box_performance_statistics'>
                                                        <div className='weight_stat'>
                                                            <span className='label_stat'>Effectivity</span>
                                                            <ProgressBar width={tEff} height={'5px'} colorUp={'#450bcc'} colorDown={'#3f354c'}/>
                                                        </div>
                                                        <div className='radiation_stat'>
                                                            <span className='label_stat'>Strength</span>
                                                            <ProgressBar width={tStr} height={'5px'} colorUp={'#450bcc'} colorDown={'#3f354c'}/>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='stats_performance_container'>
                                                    <h4>Suit Power: {suitStatistics.power}</h4>
                                                    <div className='box_performance_statistics'>
                                                        <div className='weight_stat'>
                                                            <span className='label_stat'>Weight Limit</span>
                                                            <ProgressBar width={suitStatistics.wightLimit} height={'5px'} colorUp={'#450bcc'} colorDown={'#3f354c'}/>
                                                        </div>
                                                        <div className='radiation_stat'>
                                                            <span className='label_stat'>Radiation Resistance</span>
                                                            <ProgressBar width={suitStatistics.radiationRes} height={'5px'} colorUp={'#450bcc'} colorDown={'#3f354c'}/>
                                                        </div>
                                                        <div className='firepower_stat'>
                                                            <span className='label_stat'>Energy Cost</span>
                                                            <ProgressBar width={suitStatistics.energyC} height={'5px'} colorUp={'#450bcc'} colorDown={'#3f354c'}/>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='stats_performance_container'>
                                                    <h4>Weapon Power: {weaponStatistics.power}</h4>
                                                    <div className='box_performance_statistics'>
                                                        <div className='weight_stat'>
                                                            <span className='label_stat'>Utility</span>
                                                            <ProgressBar width={weaponStatistics.utility} height={'5px'} colorUp={'#450bcc'} colorDown={'#3f354c'}/>
                                                        </div>
                                                        <div className='radiation_stat'>
                                                            <span className='label_stat'>Lethality</span>
                                                            <ProgressBar width={weaponStatistics.lethality} height={'5px'} colorUp={'#450bcc'} colorDown={'#3f354c'}/>
                                                        </div>
                                                        <div className='firepower_stat'>
                                                            <span className='label_stat'>Attack</span>
                                                            <ProgressBar width={weaponStatistics.attack} height={'5px'} colorUp={'#450bcc'} colorDown={'#3f354c'}/>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='box_reward_box'>
                                                    <span className='title_rewards_calculate'>Calculated Reward:</span>
                                                    <div className='reward_containter'>
                                                        <span className={'reward_text ' + calcReward.style}>{calcReward.text}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="box-btns-actions">
                                        {hasSuit
                                            ?   <button onClick={() => recoverSuit()} className='btn-actions'>Recover Suit</button>
                                            :   <button onClick={() => addSuit()} className='btn-actions'>Add Suit</button>
                                        }
                                        {hasWeapon
                                            ?   <button onClick={() => recoverWeapon()} className='btn-actions'>Recover Weapon</button>
                                            :   <button onClick={() => addWeapon()} className='btn-actions'>Add Weapon</button>
                                        }
                                        {(hasWeapon && hasSuit)
                                           ? <>
                                                <button onClick={() => deployTeam(location)} className='btn-actions alt_btn'>Deploy Team</button>
                                                <button className='btn-actions risky_btn' onClick={() => {
                                                                const id_risky = Number(location) + 2;
                                                                deployTeam(id_risky)
                                                }}>Deploy Risky</button>
                                           </>
                                           : <button onClick={() => deleteTeam()} className='btn-actions'>Delete Team</button>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className='item_select_section'>
                                {!hasSuit &&
                                    <div className='item_select_container'>
                                        <InventoryTeam userData={userData} locationExpe={location} itemType={'suits'} onSelect={selectorItem}/>
                                    </div>
                                }
                                {!hasWeapon &&
                                    <div className='item_select_container'>
                                        <InventoryTeam userData={userData} locationExpe={location} itemType={'weapons'} onSelect={selectorItem}/>
                                    </div>
                                }
                            </div>
                        </div>
                    </LayoutContainer>
                </>
        )
    }


    return(
        <> <LayoutContainer styles_element={{overflow: 'auto', backgroundColor: '#191819'}}>
                <div style={{width: '100%', display: 'flex', justifyContent: 'center'}}>
              {nofity.status && <ModalNotify notify={nofity} closeNotify={() => {
                        setNotify({
                            status: false,
                            error: false,
                            title: '',
                            msg: '',
                            txId: '',
                        })
                      }}/>}
              </div>
                    <button onClick={() => BackUrl()} className='backbtn'>Back</button>
                    <div className='title-box-edit-team'>
                        <h2 className='text-center'>Team Name: {dataTable.teamname}</h2>
                    </div>
                    <div className=''>
                        <div className="header-edit-team-box">
                            <div className="items_box_edit">
                                <div className="">
                                    {hasSuit
                                        ?   <ItemsVertical id={suitId} hasItem={hasSuit}/>
                                        : <>{suitSelected
                                                ?  <ItemsVertical id={idSuitSelected} hasItem={suitSelected}/>
                                                :  <ItemEmpty/>
                                            }
                                            </>
                                    }
                                </div>
                                <div className="">
                                    {hasWeapon
                                            ?   <ItemsVertical id={weaponId} hasItem={hasWeapon}/>
                                            : <>{weaponSelected
                                                    ?  <ItemsVertical id={idWeaponSelected} hasItem={weaponSelected}/>
                                                    :   <ItemEmpty/>
                                                }
                                                </>
                                    }
                                </div>
                            </div>
                            <div className='statistics_actions_box'>
                                <div className="box-statistics">
                                    <h3>Team Statistics</h3>
                                    <div className='box_progressbar_statistics'>
                                        <div className='box_progressbar'>
                                            <div className='stats_performance_container'>
                                                <h4>Team Power: {tPower}</h4>
                                                <div className='box_performance_statistics'>
                                                    <div className='weight_stat'>
                                                        <span className='label_stat'>Effectivity</span>
                                                        <ProgressBar width={tEff} height={'5px'} colorUp={'#450bcc'} colorDown={'#3f354c'}/>
                                                    </div>
                                                    <div className='radiation_stat'>
                                                        <span className='label_stat'>Strength</span>
                                                        <ProgressBar width={tStr} height={'5px'} colorUp={'#450bcc'} colorDown={'#3f354c'}/>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='stats_performance_container'>
                                                <h4>Suit Power: {suitStatistics.power}</h4>
                                                <div className='box_performance_statistics'>
                                                    <div className='weight_stat'>
                                                        <span className='label_stat'>Weight Limit</span>
                                                        <ProgressBar width={suitStatistics.wightLimit} height={'5px'} colorUp={'#450bcc'} colorDown={'#3f354c'}/>
                                                    </div>
                                                    <div className='radiation_stat'>
                                                        <span className='label_stat'>Radiation Resistance</span>
                                                        <ProgressBar width={suitStatistics.radiationRes} height={'5px'} colorUp={'#450bcc'} colorDown={'#3f354c'}/>
                                                    </div>
                                                    <div className='firepower_stat'>
                                                        <span className='label_stat'>Energy Cost</span>
                                                        <ProgressBar width={suitStatistics.energyC} height={'5px'} colorUp={'#450bcc'} colorDown={'#3f354c'}/>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='stats_performance_container'>
                                                <h4>Weapon Power: {weaponStatistics.power}</h4>
                                                <div className='box_performance_statistics'>
                                                    <div className='weight_stat'>
                                                        <span className='label_stat'>Utility</span>
                                                        <ProgressBar width={weaponStatistics.utility} height={'5px'} colorUp={'#450bcc'} colorDown={'#3f354c'}/>
                                                    </div>
                                                    <div className='radiation_stat'>
                                                        <span className='label_stat'>Lethality</span>
                                                        <ProgressBar width={weaponStatistics.lethality} height={'5px'} colorUp={'#450bcc'} colorDown={'#3f354c'}/>
                                                    </div>
                                                    <div className='firepower_stat'>
                                                        <span className='label_stat'>Attack</span>
                                                        <ProgressBar width={weaponStatistics.attack} height={'5px'} colorUp={'#450bcc'} colorDown={'#3f354c'}/>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='box_reward_box'>
                                                <span className='title_rewards_calculate'>Calculated Reward:</span>
                                                <div className='reward_containter'>
                                                    <span className={'reward_text ' + calcReward.style}>{calcReward.text}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="box-btns-actions">
                                    {hasSuit
                                        ?   <button onClick={() => recoverSuit()} className='btn-actions'>Recover Suit</button>
                                        :   <button onClick={() => addSuit()} className='btn-actions'>Add Suit</button>
                                    }
                                    {hasWeapon
                                        ?   <button onClick={() => recoverWeapon()} className='btn-actions'>Recover Weapon</button>
                                        :   <button onClick={() => addWeapon()} className='btn-actions'>Add Weapon</button>
                                    }
                                    {(hasWeapon && hasSuit)
                                       ? <button onClick={() => deployTeam(location)} className='btn-actions alt_btn'>Deploy Team</button>
                                       : <button onClick={() => deleteTeam()} className='btn-actions'>Delete Team</button>
                                    }
                                </div>
                            </div>
                        </div>
                        <div className='item_select_section'>
                            {!hasSuit &&
                                <div className='item_select_container'>
                                    <InventoryTeam userData={userData} locationExpe={location} itemType={'suits'} onSelect={selectorItem}/>
                                </div>
                            }
                            {!hasWeapon &&
                                <div className='item_select_container'>
                                    <InventoryTeam userData={userData} locationExpe={location} itemType={'weapons'} onSelect={selectorItem}/>
                                </div>
                            }
                        </div>
                    </div>
                </LayoutContainer>
            </>
    )
}

